import UnlockedFeatureCreditCriteria from "../datasets/unlocked_feature_credit_criteria";

export const checkIfCreditCardEligible = (annualSalary, creditMaxAmt, creditReport) => {
    
    let creditCardAuthorization = false;
    let creditCardCriteria = UnlockedFeatureCreditCriteria;
  
    let creditScoreOK = true;
    if (creditReport.creditScore <= creditCardCriteria.creditScoreMinimum){
        creditScoreOK = false;
    }
    let salaryMultiplier = +annualSalary / +creditMaxAmt;
    let minGrossSalary = +creditMaxAmt * +creditCardCriteria.grossIncomeMultiplier;
    let salaryAmountOK = true;
    if (salaryMultiplier < creditCardCriteria.grossIncomeMultiplier){
        salaryAmountOK = false;
    }    
    if (creditScoreOK === true &&
        salaryAmountOK === true){
            creditCardAuthorization = true;
    }   
 
    const returnObj = {creditCardAuthorization: creditCardAuthorization,
        creditScore: creditReport.creditScore, 
        creditScoreMinimum: creditCardCriteria.creditScoreMinimum,
        annualSalaryMultiplier: salaryMultiplier,
        grossIncomeMultiplier: creditCardCriteria.grossIncomeMultiplier,
        minGrossSalary: minGrossSalary
    }
    return returnObj;
}
export default checkIfCreditCardEligible;